import { render, staticRenderFns } from "./StudySelection.vue?vue&type=template&id=8e8949a6&lang=pug"
import script from "./StudySelection.vue?vue&type=script&lang=ts"
export * from "./StudySelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports